import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DriversCalendar from '../drivers-calendar.jsx';


if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-calendar')) {
  ReactDOM.render(
    <DriversCalendar
      url="/api/v1/portal/drivers/get-drivers-calendar"
      isLoading={true}
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-calendar'));
}
